import type { BulkIngestOwner } from "../../api/BulkAPI.types";

export function getBulkOwnerLines(owner: BulkIngestOwner): string[] {
  return [owner.name, owner.company, owner.email].flatMap((line) =>
    line ? [line] : [],
  );
}
